import { render, staticRenderFns } from "./commissionRule.vue?vue&type=template&id=466c7229&scoped=true"
import script from "./commissionRule.vue?vue&type=script&lang=js"
export * from "./commissionRule.vue?vue&type=script&lang=js"
import style0 from "./commissionRule.vue?vue&type=style&index=0&id=466c7229&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c7229",
  null
  
)

export default component.exports